// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import './theme/index.css'

import * as api from './api/api'
import 'nprogress/nprogress.css'  // 这个nprogress样式必须引入
import App from './App'

import Vuex from 'vuex'
import store from './store/index'
import axios from 'axios'
import * as request from './request/index'


import './assets/icon/iconfont.css'
import Qs from 'qs';
import baseUtil from './components/utils/baseUtil'

//解决ie9-浏览器兼容问题
import 'babel-polyfill';
import './icons' // icon
// 引入接口配置文件
import router from './router'
import webSocket from "./utils/webSocket";



Vue.prototype.$api = api
Vue.prototype.$axios = axios
Vue.prototype.$Qs = Qs
Vue.prototype.$ws = webSocket

Vue.config.productionTip = false;

Vue.use(Vuex);
Vue.use(ElementUI);
Vue.use(baseUtil);

Vue.prototype.$axios = axios;
Vue.prototype.$request = request;
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)

// 引入组件
import Header from "./components/Header";
import Footer from "./components/Footer";
import Appendix from "./components/UserAppendix";
import NaviTree from "./components/NaviTree";
import { Affix } from 'iview';


Vue.component('Affix', Affix);
Vue.component("Header", Header);
Vue.component("Footer", Footer);
Vue.component("Appendix", Appendix);
Vue.component('NaviTree',NaviTree);


import global_ from './components/Globle';
//全局变量库
Vue.prototype.GLOBAL = global_;  //挂载到Vue实例上面
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js